// External
import { Component, OnInit, Input, HostListener, HostBinding } from '@angular/core';

// Internal
import { DropdownService } from '../../../services/global/dropdown/dropdown.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'ui-dropdown',
    template: ` <button ui-button
                    *ngIf="iconMenu"
                    aria-haspopup="true"
                    [disabled]="disabled"
                    [iconMid]="iconMid">
                </button>
                <ng-content select="[dropdown-trigger]"></ng-content>
                <div class="dropdown-menu {{alignment}}" *ngIf="open" [ngClass]="direction">
                    <ng-content select="[dropdown-menu]"></ng-content>
                </div>`,
    exportAs: 'uiDropdown',
    host: {
        '[class.dropdown]': 'true'
    }
})

export class UiDropdownComponent implements OnInit {

    @Input() open = false;
    @Input() iconMenu = true;
    @Input() iconMid = {type: 'general', value: 'more', size: 24};
    @Input() disabled = false;
    @Input() direction = 'down';
    @Input() alignment = 'right';
    @Input() closeOnSelect = true;

    @HostBinding('class.open') dropdownOpened: boolean = this.open;


    readonly onDestroy$: Subject<void> = new Subject<void>();

    constructor(
        readonly dropdownService: DropdownService
    ) {
        dropdownService.closeAllDropdownEvent
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
            value => {
                this.dropdownClose(value);
            }
        );
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
		this.onDestroy$.next();
		this.onDestroy$.complete();
	}

    // Function that toggles between the dropdwon's 2 main states (open and closed)
    dropdownToggle(event) {
        event.stopPropagation();
        this.open  && (event.target.name === 'dropdown-trigger' || this.closeOnSelect) ? this.dropdownClose(event) : this.dropdownOpen(event);
    }

    // Function that opens the dropdown
    dropdownOpen(event) {
        this.dropdownService.closeDropdown(true);
        this.open = true;
        this.dropdownOpened = true;
    }

    // Function that closes the dropdown
    dropdownClose(event) {
        this.open = false;
        this.dropdownOpened = false;
    }

    @HostListener('document:click', ['$event']) onElseWhere(event) {
        this.dropdownClose(event);
    }

    @HostListener('click', ['$event']) onClick(event) {
        if (this.disabled) {
            return;
        }
        this.dropdownToggle(event);
    }

    @HostListener('document:keydown', ['$event']) onKeydownHandler($event) {
        switch ($event.key) {
            // case 'Enter':
            //     break;
            case 'Escape':
                this.dropdownService.closeDropdown(true);
                break;
            // case 'Tab':
            //     break;
            default:
                break;
        }
    }
}

